import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { listCitiesOptions } from '../../../features/cities/queries';
import { SourceChannelForm } from '../../../features/source-channels/components/source-channel-form';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/source-channels/new')({
  staticData: { breadcrumb: 'Новый' },
  loader: ({ context }) => context.queryClient.ensureQueryData(listCitiesOptions()),
  component: NewSourceChannelPage,
});

function NewSourceChannelPage() {
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  return (
    <div>
      <PageHeader title="Новый канал" description="Telegram-канал, с которого собираются события" />
      <SourceChannelForm mode="create" cities={cities} />
    </div>
  );
}
